// intensityTechniques.js

export const intensityTechniqueMapping = {
  warmup: {
    icon: "mdi-fire",
    descriptionShort: "Aufwärmen",
    description: "Leichte Sätze zur Vorbereitung der Muskeln auf die bevorstehende Belastung und zur Verletzungsprävention.",
    color: "orange",
    details: {
      summary: "Bereitet den Körper auf das Training vor.",
      advantages: [
        { text: "Verbessert die Durchblutung.", icon: "mdi-water-pump" },
        { text: "Erhöht die Muskeltemperatur.", icon: "mdi-thermometer-lines" },
        { text: "Reduziert das Verletzungsrisiko.", icon: "mdi-shield-check-outline" },
        { text: "Verbessert die Gelenkbeweglichkeit.", icon: "mdi-axis-arrow-lock" },
      ],
      whyDoIt: [
        { text: "Vor schweren Verbundübungen.", icon: "mdi-weight-lifter" },
        { text: "Bei kälteren Temperaturen.", icon: "mdi-snowflake" },
        { text: "Zu Beginn jeder Trainingseinheit.", icon: "mdi-ray-start-arrow" },
      ],
    },
  },
  // NEU: Hinzugefügt für Vollständigkeit
  normal: {
    icon: "mdi-format-list-bulleted",
    descriptionShort: "Normale Sätze",
    description: "Klassisches Krafttraining mit standardmäßigen Sätzen und Pausen. Die Grundlage für Muskelaufbau und Kraftsteigerung.",
    color: "grey",
    details: {
      summary: "Das Fundament des Krafttrainings.",
      advantages: [
        { text: "Stetiger Kraft- & Muskelaufbau.", icon: "mdi-chart-line" },
        { text: "Gut für Anfänger & Fortgeschrittene.", icon: "mdi-account-group-outline" },
        { text: "Einfach zu planen und zu verfolgen.", icon: "mdi-clipboard-check-outline" },
        { text: "Solide Basis für alle Ziele.", icon: "mdi-flag-checkered" },
      ],
      whyDoIt: [
        { text: "Als Hauptteil des Trainingsplans.", icon: "mdi-notebook-edit-outline" },
        { text: "Wenn Progression im Vordergrund steht.", icon: "mdi-stairs-up" },
        { text: "Für eine klare Leistungsüberwachung.", icon: "mdi-magnify-scan" },
      ],
    },
  },
  dropset: {
    icon: "mdi-trending-down",
    descriptionShort: "Dropset",
    description: "Gewicht reduzieren bei Muskelversagen, Satz ohne Pause fortsetzen. Intensiviert Ermüdung & Muskelwachstum.",
    color: "primary",
    details: {
      summary: "Gewicht runter, Satz weiter: Maximale Intensität.",
      advantages: [
        { text: "Hohe Muskelermüdung & Stress.", icon: "mdi-fire" },
        { text: "Fördert Muskelwachstum.", icon: "mdi-arm-flex-outline" },
        { text: "Überwindet Plateaus.", icon: "mdi-chart-line-variant" },
        { text: "Zeiteffiziente Intensität.", icon: "mdi-clock-fast" },
        { text: "Bessere Muskelausdauer.", icon: "mdi-battery-charging-medium" },
      ],
      whyDoIt: [
        { text: "Muskel über Grenzen fordern.", icon: "mdi-target-arrow" },
        { text: "Intensiver Übungsabschluss.", icon: "mdi-weight-lifter" },
        { text: "Schnelle, intensive Einheit.", icon: "mdi-flash" },
        { text: "Neue Wachstumsreize.", icon: "mdi-brain" },
      ],
    },
  },
  reversedropset: {
    icon: "mdi-trending-up",
    descriptionShort: "Reverse Dropset",
    description: "Mit leichtem Gewicht starten, im Satzverlauf steigern. Anders als klassische Dropsets.",
    color: "primary",
    details: {
      summary: "Gewicht rauf im Satz: Progressive Überladung.",
      advantages: [
        { text: "Progressive Last im Satz.", icon: "mdi-stairs-up" },
        { text: "Verbessert Kraft & Ausdauer.", icon: "mdi-repeat" },
        { text: "Guter Aufwärmeffekt.", icon: "mdi-weather-sunny" },
        { text: "Fördert Konzentration.", icon: "mdi-head-cog-outline" },
      ],
      whyDoIt: [
        { text: "Trainingsvariation, gegen Stagnation.", icon: "mdi-shuffle-variant" },
        { text: "Allmähliche Intensitätssteigerung.", icon: "mdi-chevron-triple-up" },
        { text: "Spezifisches Kraftausdauertraining.", icon: "mdi-timer-sand" },
        { text: "Als vorbereitende Startübung.", icon: "mdi-flag-checkered" },
      ],
    },
  },
  schockwelle: {
    icon: "mdi-lightning-bolt",
    descriptionShort: "Schockwellen-Sätze",
    description: "5 Sätze à 4 Wdh., Gewicht pro Satz steigern, kurze Pausen (30s). Startgewicht & Zuwachs anpassen.",
    color: "orange darken-2",
    details: {
      summary: "5x4 Sätze, steigendes Gewicht, kurze Pausen: Maximale Power.",
      advantages: [
        { text: "Kombiniert Kraft & Hypertrophie.", icon: "mdi-dumbbell" },
        { text: "Hohes Volumen, kurz & intensiv.", icon: "mdi-timer-settings-outline" },
        { text: "Starke Reize für Proteinsynthese.", icon: "mdi-creation" },
        { text: "Fördert Ermüdungsresistenz.", icon: "mdi-shield-star-outline" },
        { text: "Effektiv gegen Kraftplateaus.", icon: "mdi-hammer-wrench" },
      ],
      whyDoIt: [
        { text: "Kraft- & Muskelaufbau-Plateaus überwinden.", icon: "mdi-arrow-up-bold-hexagon-outline" },
        { text: "Sehr intensive, komprimierte Einheit.", icon: "mdi-timer-flash-outline" },
        { text: "Neuronale Effizienz & Maximalkraft.", icon: "mdi-head-flash-outline" },
        { text: "Starker Pump & metabolische Last.", icon: "mdi-water-pump" },
      ],
    },
  },
  fst7: {
    icon: "mdi-weight-lifter",
    descriptionShort: "FST-7",
    description: "Fascia Stretch Training: 7 Sätze à 7 Wdh. mit kurzen Pausen (30-45s) für maximalen Muskelpump.",
    color: "primary",
    details: {
      summary: "7x7 Sätze, kurze Pausen: Extremer Pump, dehnt Faszien.",
      advantages: [
        { text: "Extremer Pump, dehnt Muskelfaszie.", icon: "mdi-airballoon-outline" },
        { text: "Mehr Nährstoffe & Blut im Muskel.", icon: "mdi-blood-bag" },
        { text: "Verbessert Muskelfülle & -form.", icon: "mdi-shape-outline" },
        { text: "Hohe metabolische Belastung.", icon: "mdi-fire-circle" },
      ],
      whyDoIt: [
        { text: "Maximaler Pump, Fasziendehnung.", icon: "mdi-stretch-to-page-outline" },
        { text: "Als 'Finisher' für Muskelgruppen.", icon: "mdi-flag-variant-outline" },
        { text: "Besseres Muskelbild ('3D-Look').", icon: "mdi-cube-scan" },
        { text: "Hartnäckige Muskeln reizen.", icon: "mdi-rocket-launch-outline" },
      ],
    },
  },
  sst7: {
    icon: "mdi-stairs-box",
    descriptionShort: "SST-7",
    description:
      "Eine 7-stufige Intensitätstechnik: Die ersten 4 Sätze werden mit dem gleichen Gewicht und kurzen Pausen ausgeführt, wobei die Wdh. abnehmen (12-6-4-2). Danach folgen 3 Sätze mit reduziertem Gewicht, die auf Muskelgefühl, Bewegungstempo und statischem Halten basieren.",
    color: "red darken-2",
    details: {
      summary: "7 Stufen: 4 Sätze gleiches Gewicht, 3 Sätze Drops mit Fokus auf Tempo & Halten.",
      advantages: [
        { text: "Kombiniert Kraft, Hypertrophie & Muskelausdauer.", icon: "mdi-creation" },
        { text: "Extremer Pump durch hohes Volumen.", icon: "mdi-water-pump-full" },
        { text: "Verbessert die Muskelkontrolle & das Muskelgefühl.", icon: "mdi-brain" },
        { text: "Sehr hoher metabolischer Stress.", icon: "mdi-fire-circle" },
        { text: "Ideal zum Durchbrechen von Plateaus.", icon: "mdi-pickaxe" },
      ],
      whyDoIt: [
        { text: "Als finales 'Schock-Protokoll' für eine Muskelgruppe.", icon: "mdi-alert-decagram-outline" },
        { text: "Wenn ein neuer, starker Wachstumsreiz gesetzt werden soll.", icon: "mdi-rocket-launch-outline" },
        { text: "Für sehr fortgeschrittene Athleten mit guter Regeneration.", icon: "mdi-account-star-outline" },
        { text: "Zur Verbesserung der Mind-Muscle-Connection.", icon: "mdi-head-cog-outline" },
      ],
    },
  },
}
